import female from '../assets/img/female_avatar.png';
import male from '../assets/img/male_avatar.png';
export const getUserProfilePhoto = (userData) => {
    if (userData?.profileImageUrl) return userData.profileImageUrl;
    return userData?.gender === 'male' ? male : female;
};
export const getDefaultUserProfilePhoto = (userData) => {
    // if (userData?.profileImageUrl) return userData.profileImageUrl;
    return userData?.gender === 'male' ? male : female;
};
